export default __webpack_public_path__ + "static/media/view-grid.c0f11c6c.svg";